import { Link } from "react-router-dom";

export function Logo({ tagline = true, className = "", light = true }) {
  return (
    <Link to="/" className={`inline-flex flex-col leading-none ${className}`} data-testid="brand-logo">
      <span className="font-display font-extrabold text-2xl tracking-tight">
        <span className={light ? "text-white" : "text-[#0a1420]"}>YourRace</span>
        <span className="text-[#22d3ee]">Finder</span>
      </span>
      {tagline && (
        <span className={`font-display font-semibold text-[9px] tracking-[0.28em] mt-0.5 ${light ? "text-slate-300" : "text-slate-500"}`}>
          FIND YOUR NEXT RACE
        </span>
      )}
    </Link>
  );
}
